"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PortfolioScreenshotModal/PortfolioScreenshotImageList";

import type { FC } from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { SenderAttachmentChip } from "@/src/components/Sender/SenderAttachmentChip";
import type { SenderAttachment } from "@/src/components/Sender/type";

const I18n = I18nUtil.createScoped(Translations);

export type PortfolioScreenshotImageListProps = {
  images: SenderAttachment[];
  canAddMore: boolean;
  onRemove: (index: number) => void;
  onPickMore: () => void;
  /** Passed to SenderAttachmentChip name column (e.g. `w-[90px]` on desktop modal) */
  chipNameClassName?: string;
};

export const PortfolioScreenshotImageList: FC<
  PortfolioScreenshotImageListProps
> = ({ images, canAddMore, onRemove, onPickMore, chipNameClassName }) => {
  return (
    <div
      className="flex flex-wrap items-start gap-3"
      data-testid="portfolio-screenshot-image-list"
    >
      {images.map((attachment, index) => (
        <SenderAttachmentChip
          key={`${attachment.filename}-${index}-${attachment.url || attachment.status}`}
          attachment={attachment}
          index={index}
          nameClassName={chipNameClassName}
          onRemove={onRemove}
        />
      ))}
      {canAddMore ? (
        <button
          type="button"
          className={cn(
            "flex min-h-[44px] items-center gap-1 rounded-3 border border-dashed border-border_white_transparent20 px-3 py-2",
            "body_medium_l text-content_primary",
          )}
          data-testid="portfolio-screenshot-upload-more"
          onClick={onPickMore}
        >
          <Icon name="plus" size={20} className="text-content_primary" />
          {I18n.t("Upload")}
        </button>
      ) : null}
    </div>
  );
};
